export default __webpack_public_path__ + "static/media/Text-BalanceReload@2x.08756de0.png";